export default __webpack_public_path__ + "assets/models/3d79479ee6cb3cd73dba766c85a16b49.glb";